import CmsApiService from "@/services/api/cms";
import { type ICmsCompanion, type INavMenuItem } from "@/types";
import { ref } from "vue";
import lookAndFeel from "@/config/lookAndFeel";
import { createTipTapRichText } from "@/utilities/createTipTapRichText";

const FALLBACK_MAIN_ITEMS: INavMenuItem[] = [
  { label: "Über das Projekt", url: "/about", isExternal: false },
  { label: "Über unsere Quellen", url: "/publishers", isExternal: false },
  { label: "Medium vorschlagen", url: "/suggest", isExternal: false },
  { label: "Hilfe / FAQs", url: "/faq", isExternal: false },
  { label: "Kontakt", url: "/contact", isExternal: false },
];

const FALLBACK_SUPPLEMENTAL_ITEMS: INavMenuItem[] = [
  { label: "Datenschutz", url: "/data-protection", isExternal: false },
  { label: "Impressum", url: "/imprint", isExternal: false },
  { label: "Erklärung zur Barrierefreiheit", url: "/accessibility", isExternal: false },
];

const mapFallbackCompanions = (): ICmsCompanion[] =>
  lookAndFeel.companionList.map((c) => ({
    image: { url: `/images/partners/${c.imageFileName}`, alternativeText: c.alt },
    url: c.url ?? null,
  }));

export const useCmsFooterConfig = () => {
  const mainItems = ref<INavMenuItem[]>(FALLBACK_MAIN_ITEMS);
  const supplementalItems = ref<INavMenuItem[]>(FALLBACK_SUPPLEMENTAL_ITEMS);
  const description = ref<string>(createTipTapRichText(lookAndFeel.description));
  const companions = ref<ICmsCompanion[]>(mapFallbackCompanions());
  const logoUrl = ref<string>(lookAndFeel.logoFooterFileUrl);

  const fetchFooterConfig = async () => {
    const result = await CmsApiService.getFooterConfig();
    if (result?.mainItems?.length) {
      mainItems.value = result.mainItems;
    }
    if (result?.supplementalItems?.length) {
      supplementalItems.value = result.supplementalItems;
    }
    if (result?.description) {
      description.value = result.description;
    }
    if (result?.companions?.length) {
      companions.value = result.companions;
    }
    if (result?.logo?.url) {
      logoUrl.value = result.logo.url;
    }
  };

  fetchFooterConfig();

  return { mainItems, supplementalItems, description, companions, logoUrl };
};
